import { cn } from '@/shared/lib'
import { designTokens } from '@/shared/lib/design-tokens'
import { CloudPaymentLogo, DolamiLogo, MirLogo } from './payment-method-icons'

export type PaymentMethodCardVariant = 'cloud-payment' | 'dolami' | 'saved-card'
export type PaymentMethodCardWidthMode = 'fixed' | 'fill'

export type PaymentMethodCardProps = {
  variant: PaymentMethodCardVariant
  label?: string | null
  selected?: boolean
  disabled?: boolean
  onSelect?: () => void
  widthMode?: PaymentMethodCardWidthMode
  className?: string
}

const labelMap: Record<PaymentMethodCardVariant, string | null> = {
  'cloud-payment': 'Новая карта',
  dolami: null,
  'saved-card': '**8810',
}

export function PaymentMethodCard({
  variant,
  label,
  selected = false,
  disabled = false,
  onSelect,
  widthMode = 'fixed',
  className,
}: PaymentMethodCardProps) {
  const resolvedLabel = label ?? labelMap[variant]
  const labelVisible = Boolean(resolvedLabel)

  const borderColor = selected
    ? designTokens.colors.border.paymentSelected
    : designTokens.colors.border.light

  const paddingY = labelVisible
    ? designTokens.spacing.xs
    : selected
      ? designTokens.spacing.paymentMethodLabelOffSelectedY
      : designTokens.spacing.paymentMethodLabelOffUnselectedY

  const alignItems = 'center'
  const gap = labelVisible
    ? designTokens.spacing.paymentMethodLogoGap
    : designTokens.spacing.paymentMethodLogoGapNone

  return (
    <button
      type="button"
      className={cn('flex w-full flex-col justify-between', className)}
      style={{
        width:
          widthMode === 'fill'
            ? designTokens.sizes.width.fill
            : designTokens.sizes.width.paymentMethodCard,
        minHeight: designTokens.sizes.minHeight.paymentMethodCard,
        padding: `${paddingY} ${designTokens.spacing.cardOptionX}`,
        gap,
        alignItems,
        borderRadius: designTokens.borders.radius.sm,
        borderWidth: designTokens.borders.widths.thin,
        borderStyle: designTokens.borders.styles.solid,
        borderColor,
        background: disabled ? 'rgba(255, 255, 255, 0.72)' : designTokens.colors.background.surface,
        opacity: disabled ? 0.56 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      aria-pressed={selected}
      aria-disabled={disabled}
      onClick={onSelect}
      disabled={disabled}
    >
      <div className="flex w-full items-center justify-center">
        {variant === 'cloud-payment' ? (
          <CloudPaymentLogo />
        ) : variant === 'saved-card' ? (
          <MirLogo />
        ) : (
          <DolamiLogo />
        )}
      </div>
      {labelVisible ? (
        <span
          style={{
            fontFamily: designTokens.typography.fontFamilies.primary,
            fontSize: designTokens.typography.captionXs.size,
            lineHeight: designTokens.typography.captionXs.lineHeight,
            fontWeight: designTokens.typography.captionXs.weight,
            color: designTokens.colors.text.secondary,
            textAlign: 'center',
            width: '100%',
          }}
        >
          {resolvedLabel}
        </span>
      ) : null}
    </button>
  )
}
